"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_2md32ogvr4 = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/Repository.js";
  var hash = "eedef7517a0ceeffa64c5d52c754771fdf9f65d8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/Repository.js",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "1": {
        start: {
          line: 18,
          column: 41
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "3": {
        start: {
          line: 24,
          column: 26
        },
        end: {
          line: 24,
          column: 63
        }
      },
      "4": {
        start: {
          line: 26,
          column: 18
        },
        end: {
          line: 29,
          column: 19
        }
      },
      "5": {
        start: {
          line: 27,
          column: 17
        },
        end: {
          line: 27,
          column: 43
        }
      },
      "6": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 18
        }
      },
      "7": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 33,
          column: 28
        }
      },
      "8": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 56
        }
      },
      "9": {
        start: {
          line: 32,
          column: 46
        },
        end: {
          line: 32,
          column: 56
        }
      },
      "10": {
        start: {
          line: 35,
          column: 24
        },
        end: {
          line: 37,
          column: 26
        }
      },
      "11": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 23
        }
      },
      "12": {
        start: {
          line: 39,
          column: 72
        },
        end: {
          line: 39,
          column: 76
        }
      },
      "13": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 70,
          column: 4
        }
      },
      "14": {
        start: {
          line: 62,
          column: 14
        },
        end: {
          line: 62,
          column: 46
        }
      },
      "15": {
        start: {
          line: 73,
          column: 0
        },
        end: {
          line: 95,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 29
          },
          end: {
            line: 18,
            column: 30
          }
        },
        loc: {
          start: {
            line: 18,
            column: 41
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 18
      },
      "1": {
        name: "Repository",
        decl: {
          start: {
            line: 22,
            column: 9
          },
          end: {
            line: 22,
            column: 19
          }
        },
        loc: {
          start: {
            line: 22,
            column: 63
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 30
          },
          end: {
            line: 26,
            column: 31
          }
        },
        loc: {
          start: {
            line: 26,
            column: 42
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        },
        loc: {
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 35,
            column: 36
          },
          end: {
            line: 35,
            column: 37
          }
        },
        loc: {
          start: {
            line: 35,
            column: 42
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 35
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 61,
            column: 21
          },
          end: {
            line: 61,
            column: 22
          }
        },
        loc: {
          start: {
            line: 61,
            column: 27
          },
          end: {
            line: 63,
            column: 13
          }
        },
        line: 61
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 35
          },
          end: {
            line: 24,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 35
          },
          end: {
            line: 24,
            column: 45
          }
        }, {
          start: {
            line: 24,
            column: 49
          },
          end: {
            line: 24,
            column: 62
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 56
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 56
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 25
          }
        }, {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 52,
            column: 45
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 53
          },
          end: {
            line: 56,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 53
          },
          end: {
            line: 56,
            column: 62
          }
        }, {
          start: {
            line: 56,
            column: 66
          },
          end: {
            line: 56,
            column: 70
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "eedef7517a0ceeffa64c5d52c754771fdf9f65d8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _core2 = require("../../core");

var _localStrings = require("../../core/localStrings");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_2md32ogvr4.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_2md32ogvr4.f[0]++;
  cov_2md32ogvr4.s[1]++;
  return {
    avatar: {
      borderRadius: '20%'
    }
  };
}));

function Repository(_ref) {
  var url = _ref.url,
      repository = _ref.repository,
      onRepository = _ref.onRepository,
      config = _ref.config;
  cov_2md32ogvr4.f[1]++;
  var classes = (cov_2md32ogvr4.s[2]++, useStyles());

  var _ref2 = (cov_2md32ogvr4.s[3]++, (0, _react.useState)((cov_2md32ogvr4.b[0][0]++, repository) || (cov_2md32ogvr4.b[0][1]++, {
    owner: {}
  }))),
      _ref3 = _slicedToArray(_ref2, 2),
      repo = _ref3[0],
      setRepo = _ref3[1];

  var getData = (cov_2md32ogvr4.s[4]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cov_2md32ogvr4.f[2]++;
            cov_2md32ogvr4.s[5]++;
            _context.next = 4;
            return (0, _core2.get)({
              url: url,
              config: config
            });

          case 4:
            data = _context.sent;
            cov_2md32ogvr4.s[6]++;
            setRepo(data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [config, url]));
  cov_2md32ogvr4.s[7]++;
  (0, _react.useEffect)(function () {
    cov_2md32ogvr4.f[3]++;
    cov_2md32ogvr4.s[8]++;

    if (Object.keys(repo.owner).length === 0) {
      cov_2md32ogvr4.b[1][0]++;
      cov_2md32ogvr4.s[9]++;
      getData();
    } else {
      cov_2md32ogvr4.b[1][1]++;
    }
  }, [getData, repo.owner]);

  var _onRepository = (cov_2md32ogvr4.s[10]++, (0, _react.useCallback)(function () {
    cov_2md32ogvr4.f[4]++;
    cov_2md32ogvr4.s[11]++;
    onRepository(repo);
  }, [repo, onRepository]));

  var _ref5 = (cov_2md32ogvr4.s[12]++, repo),
      owner = _ref5.owner,
      name = _ref5.name,
      full_name = _ref5.full_name,
      description = _ref5.description,
      html_url = _ref5.html_url,
      avatar_url = _ref5.avatar_url;

  cov_2md32ogvr4.s[13]++;
  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    "data-test": "repository-item",
    alignItems: "flex-start",
    button: true,
    ContainerComponent: "div",
    onClick: _onRepository
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, null, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    alt: owner.fullname,
    src: (cov_2md32ogvr4.b[2][0]++, avatar_url) || (cov_2md32ogvr4.b[2][1]++, owner.avatar_url),
    className: classes.avatar
  })), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: description,
    secondary: (cov_2md32ogvr4.b[3][0]++, full_name) || (cov_2md32ogvr4.b[3][1]++, name)
  }), /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: (0, _localStrings.localString)('OpenRepo'),
    arrow: true
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "Open Link",
    onClick: function onClick() {
      cov_2md32ogvr4.f[5]++;
      cov_2md32ogvr4.s[14]++;
      window.open(html_url, '_blank');
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Code, null)))));
}

cov_2md32ogvr4.s[15]++;
Repository.propTypes = {
  /** Repository data to render, if url not provided. */
  repository: _propTypes.default.shape({
    id: _propTypes.default.number,
    owner: _propTypes.default.object.isRequired,
    name: _propTypes.default.string.isRequired,
    full_name: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    html_url: _propTypes.default.string.isRequired,
    website: _propTypes.default.string.isRequired,
    tree_url: _propTypes.default.string,
    avatar_url: _propTypes.default.string,
    branch: _propTypes.default.string
  }),

  /** Function to call when repository is selected. */
  onRepository: _propTypes.default.func.isRequired,

  /** Url to get repository data, if repository data is not provided. */
  url: _propTypes.default.string,

  /** Configuration required if paths are provided as URL. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  })
};
var _default = Repository;
exports.default = _default;